<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">C<span class="smallcaps">ONTENTS</span></h1>
<p class="toc-fm"><a href="#/006_Figures#fm-1">List of Figures</a></p>
<p class="toc-fm"><a href="#/007_Foreword#fm-2">Foreword <span class="rom">by Mark Goodacre</span></a></p>
<p class="toc-fm"><a href="#/008_Abbreviations#fm-3">List of Abbreviations</a></p>
<p class="toc-fm1"><a href="#/009_Introduction#fm-4">Introduction</a></p>
<p class="toc-chap"><span href="#/010_Chapter01#ch-1" title="Link target outside of Sample">1. <span class="pad10">How to Write a Gospel</span></span></p>
<p class="toc-chap"><span href="#/011_Chapter02#ch-2" title="Link target outside of Sample">2. <span class="pad10">Synoptic Trajectories</span></span></p>
<p class="toc-chap"><span href="#/012_Chapter03#ch-3" title="Link target outside of Sample">3. <span class="pad10">Johannine Trajectories</span></span></p>
<p class="toc-chap"><span href="#/013_Chapter04#ch-4" title="Link target outside of Sample">4. <span class="pad10">Johannine Christology in Context</span></span></p>
<p class="toc-bm1"><span href="#/014_Conclusion#bm-1" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc-bm"><span href="#/015_Acknowledgments#bm-2" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc-bm"><span href="#/016_Bibliography#bm-3" title="Link target outside of Sample">Bibliography</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Contents.vue?8220c7d0